/**
 * Route map aligned with MNG_ModuleLists controllers (market-growth-submodule-menus.json).
 *
 * Standard paths:
 *   /SLN/MarketGrowth/{Controller}
 *   /SLN/MarketGrowth/LeadCampaigns/{Controller}
 */

export const MARKET_GROWTH_MODULE = "MarketGrowth";
export const LEAD_CAMPAIGNS_MODULE = "LeadCampaigns";

/** Direct children of MarketGrowth (TreeId = 19500) */
export const MARKET_GROWTH_PAGE_CONTROLLERS = [
  "Dashboard",
  "Partners",
  "PartnerApprovals",
  "Network",
  "CommissionGroups",
  "CommissionRules",
  "Attributions",
  "Commissions",
  "Payouts",
  "FraudAlerts",
  "AuditLogs",
  "Settings",
  "PartnerLeads",
];

/** Children of LeadCampaigns (TreeId = 19513) */
export const LEAD_CAMPAIGN_PAGE_CONTROLLERS = [
  "Dashboard",
  "Groups",
  "Campaigns",
  "Reports",
];

/**
 * Flat paths sometimes emitted when LeadCampaigns grouping is skipped in menu tree.
 * Redirect to canonical nested paths (Dashboard excluded — MG has its own Dashboard).
 */
export const LEAD_CAMPAIGN_FLAT_REDIRECTS = {
  Groups: "LeadCampaigns/Groups",
  Campaigns: "LeadCampaigns/Campaigns",
  Reports: "LeadCampaigns/Reports",
};

export const buildMarketGrowthPath = (...segments) =>
  ["/SLN", MARKET_GROWTH_MODULE, ...segments.filter((s) => s != null && s !== "")]
    .join("/");

export const buildLeadCampaignPath = (controller, detailId) => {
  const base = buildMarketGrowthPath(LEAD_CAMPAIGNS_MODULE, controller);
  return detailId != null && detailId !== "" ? `${base}/${detailId}` : base;
};
